export default {
  "header": {
    "navTool": "Herramienta",
    "navExamples": "Ejemplos",
    "navFairHousing": "Vivienda Justa",
    "navPresentation": "Presentación",
    "navBlog": "Blog",
    "navPricing": "Precios",
    "tryFree": "Prueba Gratis →",
    "esToggle": "🇪🇸 ES",
    "enToggle": "🇺🇸 EN"
  },
  "common": {
    "loading": "Cargando…",
    "error": "Algo salió mal. Intenta de nuevo.",
    "copied": "¡Copiado!",
    "copy": "Copiar",
    "close": "Cerrar",
    "preview": "Vista previa",
    "noCard": "Sin tarjeta",
    "cancelAnytime": "cancela cuando quieras",
    "moneyBack30": "Garantía de 30 días",
    "billedUSD": "facturado en USD",
    "tryFree": "Prueba Gratis — Sin Tarjeta",
    "learnMore": "Saber Más →",
    "previewAll": "Ver Todas las Páginas →"
  },
  "hero": {
    "est": "EST. 2026 — COPY INMOBILIARIO, REESCRITO",
    "headline1": "ChatGPT escribe",
    "headline2": "violaciones de Vivienda Justa por $26,262.",
    "headline3": "Nosotros las detectamos.",
    "subtitle": "Un pegado → copia para MLS, revisión de Vivienda Justa, caption de Instagram, 5 titulares, email para compradores. 10 segundos. Cero riesgo normativo.",
    "subtitle2": "Escribe tu listado en 60 segundos en vez de una hora. Prueba el playground gratis. Sin tarjeta. Ve la diferencia tú mismo.",
    "formats": [
      "Descripción MLS",
      "Caption Instagram",
      "Publicación Facebook",
      "5 Titulares",
      "Email Comprador"
    ],
    "formatsTag": "— un solo clic.",
    "fhPlaceholder": "Pega tu listado aquí",
    "fhExample": "Ejemplo: \"Perfecto para familias con niños. Vecindario seguro y tranquilo cerca de las mejores escuelas.\"",
    "fhMinChars": "Mín. 20 caracteres",
    "fhCheck": "Revisar violaciones",
    "fhChecking": "Revisando…",
    "fhFree": "✦ 100% gratis",
    "fhNoAccount": "● Sin cuenta",
    "fh5Sec": "● 5 segundos",
    "fhClean": "Sin violaciones encontradas",
    "fhCleanMsg": "Tu listado pasó la revisión de Vivienda Justa.",
    "fhRewrite": "Reescribir con IA ahora",
    "fhCheckAnother": "Revisar otro",
    "fhViolations": "{count} violación(es) — riesgo {risk}",
    "fhIssues": "Este listado tiene problemas de Vivienda Justa.",
    "fhFix": "Corregir con IA — Prueba Gratis",
    "fhError": "Algo salió mal. Intenta de nuevo.",
    "bullets": [
      "✦ Acceso ilimitado al playground",
      "● Sin tarjeta de crédito",
      "● 10s por listado",
      "● Revisión de Vivienda Justa"
    ]
  },
  "playground": {
    "sectionLabel": "/ La Herramienta",
    "toolsLabel": "Explorar Todas Las Herramientas",
    "heading": "Tu listado aburrido en.",
    "heading2": "Cinco activos listos para publicar.",
    "inputLabel": "Entrada · Listado Crudo",
    "useSample": "Usar ejemplo →",
    "placeholder": "Pega tu borrador de MLS aquí. Entre más detalles, mejor el resultado.",
    "tone": "Tono",
    "tones": [
      "De lujo",
      "Acogedor",
      "Moderno",
      "Minimalista",
      "Familiar",
      "Inversionista"
    ],
    "outputLang": "Idioma de Salida",
    "mlsLimit": "Límite de Caracteres MLS",
    "mlsPresets": [
      "Sin límite / Predeterminado",
      "Bright MLS — 350 palabras",
      "CRMLS — 400 palabras",
      "GAMLS — 350 palabras",
      "Stellar MLS — 300 palabras",
      "MRED — 350 palabras",
      "REcolorado — 350 palabras",
      "Metrolist — 400 palabras",
      "ACTRIS — 300 palabras",
      "Personalizado — 250 palabras",
      "Personalizado — 500 palabras"
    ],
    "startFree": "Empieza Gratis — Reescribe Este Listado",
    "rewrite": "Reescribir Mi Listado",
    "rewriting": "Reescribiendo…",
    "freeNote": "3 reescrituras gratis, luego desde $19/mes · cancela cuando quieras",
    "awaiting": "Esperando entrada",
    "awaitingMsg": "Tu listado reescrito aparecerá aquí.",
    "awaitingHint": "Pega un borrador, elige un tono, presiona reescribir. Cinco activos listos en unos 10 segundos.",
    "generating": "Generando",
    "copyCrush": "Copiar y Publicar",
    "copied": "Copiado",
    "share": "Compartir",
    "strength": "Fuerza {score}/10",
    "proTip": "Consejo: Lee esto directo a la cámara de tu teléfono. Sin teleprompter.",
    "tabs": {
      "mls": "Descripción MLS",
      "instagram": "Instagram",
      "facebook": "Facebook",
      "headlines": "Titulares",
      "email": "Email",
      "reel": "Guión del Reel",
      "stories": "Historias",
      "flyer": "Volante Impreso"
    },
    "proUpsell": "ListWorks PRO",
    "proUpsellMsg": "Reescrituras ilimitadas · videos sin marca de agua · el Asesor IA en tu bolsillo.",
    "getPro": "Obtén Pro — $29/mes",
    "tools": {
      "rewrite": "Reescribir Listado",
      "staging": "Ambientación Virtual",
      "bio": "Biografía del Agente",
      "photo": "Foto → Listado",
      "agentpage": "Página del Agente",
      "cma": "Informe ACM",
      "brandvoice": "Voz de la Marca",
      "referral": "Refiere y Gana",
      "batch": "CSV por Lote",
      "expired": "Guiones para Vencidos",
      "import": "Importar URL",
      "seller": "Informes para Vendedores",
      "nurture": "Nutrir Leads",
      "score": "Puntuar Leads",
      "transaction": "Transacciones",
      "openhouse": "Casa Abierta",
      "fairhousing": "Vivienda Justa",
      "coact": "Divulgación de IA",
      "voice": "Camina y Habla",
      "report": "Informe de Venta",
      "templates": "Plantillas Sociales",
      "calendar": "Calendario de Contenido",
      "marketupdate": "Actualización de Mercado",
      "scheduler": "Programar Publicaciones"
    },
    "meta": {
      "address": "Dirección (opcional)",
      "price": "Precio",
      "beds": "Camas",
      "baths": "Baños",
      "sqft": "pies²",
      "virtualTour": "Recorrido Virtual 360°",
      "virtualTourPlaceholder": "https://my.matterport.com/show/?m=..."
    },
    "gems": {
      "button": "Ver Escuelas · Restaurantes · Vecindario →",
      "loading": "Obteniendo datos del vecindario…",
      "heading": "Datos del Barrio",
      "add": "Agregar a mi listado →",
      "added": "Contexto del vecindario añadido a tu listado."
    },
    "lookup": {
      "button": "Llenar automático · baños · pies² →",
      "loading": "Buscando…",
      "success": "Detalles de la propiedad rellenados automáticamente.",
      "notFound": "No se encontraron datos públicos — llénalo manualmente."
    }
  },
  "proof": {
    "sectionLabel": "/ Comprobantes",
    "headline": "El mismo listado. Su vecindario, escrito.",
    "before": "Antes",
    "beforeSub": "Borrador genérico",
    "after": "Después / ListWorks",
    "afterSub": "+ Inteligencia del Vecindario — auto-agregado",
    "strength": "Fuerza del Listado",
    "strengthScore": "{score}/10",
    "stronger": "+{percent}% más fuerte",
    "rewrite": "Reescribe el Tuyo",
    "freeCTA": "3 reescrituras gratis · Sin tarjeta de crédito · Ve la diferencia en 10 segundos",
    "examplesLabel": "/ Ejemplos Completos",
    "examplesTitle": "Pruébalos en el playground.",
    "examplesCTA": "Prueba tu dirección →",
    "neighborhood": "Inteligencia del Vecindario",
    "neighborhoodSub": "Pruébalo con cualquier dirección de EE.UU.",
    "neighborhoodPlaceholder": "Empieza a escribir una dirección...",
    "neighborhoodFetch": "Buscar",
    "neighborhoodSchools": "Escuelas",
    "neighborhoodDining": "Restaurantes",
    "neighborhoodTransit": "Transporte",
    "neighborhoodEmpty": "aparecerá aquí",
    "neighborhoodAdd": "Agregar a mi listado",
    "geoloading": "Obteniendo escuelas, restaurantes y datos de tránsito…"
  },
  "presentation": {
    "sectionLabel": "/ Gana más Listados",
    "heading": "55 Páginas",
    "heading2": "Presentación de Venta",
    "subtitle": "Plantilla rellenable. Hojas de trabajo ACM, calculadora de ingreso neto, calendario de marketing, páginas de cumplimiento normativo. Funciona en tu navegador — sin software.",
    "buy": "Comprar Plantilla — $27",
    "cover": "Portada",
    "cma": "Hoja de Trabajo ACM",
    "netProceeds": "Ingreso Neto",
    "mktgCalendar": "Calendario de Marketing",
    "sections": "36 Secciones Rellenables",
    "guarantee": "Descarga inmediata · HTML + PDF editable · Actualizaciones gratis · Garantía de 30 días"
  },
  "pricing": {
    "sectionLabel": "/ Precios",
    "headline": "Empieza gratis. Escala sin límites.",
    "flatRate": "Una sola tarifa plana",
    "noLimits": "Sin límites de crédito",
    "unlimited": "Reescrituras ilimitadas",
    "free": {
      "name": "Gratis",
      "price": "$0",
      "period": "siempre",
      "desc": "Para agentes que quieren probarlo en su próximo listado.",
      "features": [
        "Acceso ilimitado al playground",
        "Todos los 5 formatos de salida",
        "6 modos de tono",
        "Revisión de Vivienda Justa",
        "Ve los resultados antes de guardar"
      ],
      "cta": "Empezar Gratis"
    },
    "agent": {
      "tag": "Para Agentes Individuales",
      "name": "Agente",
      "price": "$19",
      "period": "/ mes",
      "desc": "Reescrituras ilimitadas, revisión de Vivienda Justa y tu voz de marca — todo lo que un agente individual necesita.",
      "features": [
        "Reescrituras de listados ilimitadas",
        "31 plantillas sociales con tu voz de marca",
        "Generador de calendario de contenido de 30 días",
        "Generador de actualización de mercado en vivo",
        "Programador de publicaciones con recordatorios por email",
        "Importación de URL de cualquier listado (Zillow, Redfin, MLS…)",
        "Revisión de Vivienda Justa + PDF de cumplimiento CO Act",
        "Generador de Biografía del Agente (3 formatos)",
        "Videos sin marca de agua",
        "Historial de listados (para siempre)"
      ],
      "cta": "Obtén Agente — $19/mes"
    },
    "pro": {
      "tag": "Recomendado",
      "name": "Pro",
      "price": "$39",
      "period": "/ mes",
      "desc": "Todo lo de Agente más extracción de fotos, créditos de staging IA, recorridos en video y páginas de aterrizaje.",
      "features": [
        "Todo lo de Agente",
        "Extracción de características de fotos",
        "Recorridos en video con IA (sin marca de agua)",
        "20 créditos de staging IA / mes",
        "Página de aterrizaje + captura de leads QR",
        "Múltiples perfiles de voz de marca",
        "Generador de guiones para reels",
        "Generación prioritaria de videos",
        "Soporte prioritario"
      ],
      "cta": "Obtén Pro — $39/mes"
    },
    "credits": {
      "label": "/ Créditos — paga sobre la marcha",
      "note": "· Cada crédito = una reescritura completa · nunca caducan",
      "10": {
        "qty": "10 Créditos",
        "price": "$5",
        "desc": "10 reescrituras de IA — sin vencimiento.",
        "badge": "Paga sobre la marcha"
      },
      "50": {
        "qty": "50 Créditos",
        "price": "$19",
        "desc": "50 reescrituras de IA — el mejor valor sobre la marcha.",
        "badge": "Ahorra 24%"
      }
    },
    "brokerage": "¿Necesitas 10+ asientos? Habla con ventas para corretajes →"
  },
  "faq": {
    "sectionLabel": "/ Preguntas Frecuentes",
    "headline": "Las preguntas que siempre nos hacen.",
    "email": "¿No ves la tuya? Envía un email a hello@listworks.pro",
    "items": [
      {
        "q": "¿Esto son solo plantillas?",
        "a": "No. ListWorks es un sistema envuelto en una herramienta. Aprendes POR QUÉ funciona cada pieza — luego la IA lo aplica a cada listado en tu voz. Las plantillas copian. Los sistemas se acumulan."
      },
      {
        "q": "¿Tengo que usar IA?",
        "a": "No. La guía de $20 enseña el sistema completo para que puedas escribir mejor copia a mano. La herramienta de IA solo lo hace 27 minutos más rápido por listado."
      },
      {
        "q": "¿Va a sonar como ChatGPT?",
        "a": "Para nada. Los resultados genéricos de ChatGPT son mediocres porque están entrenados con todos los listados de internet — incluidos los malos. ListWorks está ajustado con el sistema Característica → Beneficio → Sentimiento que los agentes del 1% superior realmente usan."
      },
      {
        "q": "¿Y si no me gusta?",
        "a": "Garantía de devolución de 30 días en la guía. El playground de la herramienta es completamente gratis con acceso ilimitado — pruébalo tantas veces como quieras antes de decidir actualizar."
      },
      {
        "q": "¿Es compatible con MLS?",
        "a": "Sí. Los resultados evitan trampas de vivienda justa, hipérboles y afirmaciones no verificables por defecto. Siempre revisa antes de publicar — como con cualquier borrador."
      },
      {
        "q": "¿Puede usarlo toda mi corretaje?",
        "a": "Sí — el plan Equipo incluye 5 asientos, bibliotecas de listados compartidas y ajustes de voz específicos para la corretaje. Envía un email a hello@listworks.pro para una demostración."
      },
      {
        "q": "¿En qué se diferencia de ChatGPT?",
        "a": "ChatGPT te da texto inmobiliario genérico porque está entrenado con todo internet. ListWorks está entrenado con el sistema Característica → Beneficio → Sentimiento — el mismo que usan los agentes del 1% superior para cerrar. Un solo prompt, cero relleno."
      },
      {
        "q": "¿Las publicaciones de Instagram y Facebook realmente funcionan?",
        "a": "Sí. Más de 200 agentes las usan semanalmente. Jessica Martínez (LA) cerró 2 listados en menos de una semana con publicaciones generadas aquí. Priya Nair (Chicago) dice que sus DMs de IG se triplicaron. Los captions están diseñados para detener el desplazamiento, no para la vanidad."
      }
    ]
  },
  "footer": {
    "tagline": "Copia inmobiliaria, reescrita.",
    "desc": "Creado para agentes que prefieren vender casas que mirar formularios de MLS. Prueba la herramienta gratis. Lee la guía una vez. Úsala para siempre.",
    "product": "Producto",
    "productLinks": [
      "La Herramienta",
      "Ejemplos",
      "Blog",
      "Herramientas Gratis",
      "Estadísticas de Mercado",
      "Comparar",
      "Precios"
    ],
    "compliance": "Cumplimiento",
    "complianceLinks": [
      "Guía de Vivienda Justa",
      "Guías de los 50 Estados",
      "Divulgación de IA CO",
      "Analizador de Listados"
    ],
    "earn": "Gana",
    "earnLinks": [
      "Hazte Afiliado",
      "Panel de Afiliados",
      "Contacto"
    ],
    "company": "Empresa",
    "companyLinks": [
      "Privacidad",
      "Términos"
    ],
    "newsletter": "Boletín",
    "newsletterDesc": "Una carta / mes. El sistema, refinado. Sin spam.",
    "newsletterPlaceholder": "agente@corretaje.com",
    "copyright": "© 2026 ListWorks PRO · Hecho para agentes"
  },
  "video": {
    "sectionLabel": "/ Motor de Video",
    "demo": "Demo en vivo",
    "headline1": "Diez fotos.",
    "headline2": "Un reel cinematográfico",
    "headline3": "listo.",
    "desc": "Sin software de edición. Sin horas extra. Solo sube las fotos de tu listado — la IA escribe el guión, elige la música y renderiza un recorrido de 30 segundos listo para Instagram, Facebook y tu campaña de email.",
    "inputLabel": "ENTRADA — 10 FOTOS CRUDAS",
    "outputLabel": "RENDERIZADO EN 8 SEGUNDOS",
    "overlay": "Generado por IA · Demo de 30s",
    "makeReel": "Hacer Mi Reel de Listado",
    "seePlans": "Ver planes →",
    "stats": [
      {
        "value": "10",
        "label": "Fotos"
      },
      {
        "value": "30s",
        "label": "Duración Final"
      },
      {
        "value": "1080p",
        "label": "Calidad MP4"
      },
      {
        "value": "9:16",
        "label": "Formato Reels (Pro)"
      }
    ]
  },
  "contentEngine": {
    "sectionLabel": "/ Paquete de Salida",
    "headline": "Una entrada. Seis salidas listas para publicar.",
    "tabs": [
      "Guión del Reel",
      "Caption Instagram",
      "Carrusel de 6 Diapositivas",
      "Calendario de 7 Días",
      "Informe de Mercado",
      "Plantillas Canva"
    ],
    "reel": {
      "hook": "Gancho (0–3s)",
      "middle": "Desarrollo (3–12s)",
      "close": "Cierre (12–15s)"
    }
  },
  "qr": {
    "sectionLabel": "/ Herramientas QR",
    "headline": "Cada listado se convierte en un punto de captura de leads.",
    "signQr": "QR para el Letrero",
    "signSub": "Cada letrero = un imán de leads",
    "signStep1": "Reescribe cualquier listado",
    "signStep2": "Descarga el código QR",
    "signStep3": "Ponlo en tu letrero de \"Recién Listado\"",
    "signStep4": "El comprador escanea → ve el listado en su teléfono → tú obtienes el lead",
    "signDetail": "Página completa del listado con fotos, descripción, copia conforme a Vivienda Justa y un formulario de contacto. Tu lead se captura en el momento en que escanean.",
    "openHouse": "Registro para Casa Abierta",
    "openSub": "Contactos autocapturados",
    "openStep1": "Crea un evento de registro en tu panel",
    "openStep2": "Imprime el código QR",
    "openStep3": "Pégalo en la puerta principal",
    "openStep4": "Los visitantes escanean → dejan nombre + email → no más hojas de registro en papel",
    "openDetail": "Un formulario de registro amigable para móviles. Nombre + email + teléfono opcional. Toma 10 segundos. Todos los leads van directo a tu panel con marca de tiempo.",
    "feedback": "Retroalimentación de la Visita",
    "feedbackSub": "Retroalimentación + lead en una sola lectura",
    "feedbackStep1": "Imprime la tarjeta QR",
    "feedbackStep2": "Déjala en el mostrador después de una visita",
    "feedbackStep3": "El comprador escanea → califica 1–5 + deja comentario + email",
    "feedbackStep4": "Obtienes retroalimentación accionable Y un lead caliente",
    "feedbackDetail": "Un formulario de calificación de 5 estrellas + caja de comentarios + captura de contacto. Los compradores dejan comentarios anónimamente O dejan su información si están interesados. Tú obtienes ambas.",
    "seeWhat": "Haz clic para ver lo que ven los compradores →",
    "collapse": "Haz clic para colapsar ↑",
    "buyerSee": "Lo que ven los compradores:",
    "footer": "Sin necesidad de instalar app · Funciona en cualquier teléfono · Cada lectura capturada en tu panel"
  },
  "contracts": {
    "sectionLabel": "/ Contratos",
    "headline": "Contratos que se explican solos.",
    "desc": "Cada campo en cada contrato tiene una explicación en español claro. No más adivinar qué significa ‘comisión del corredor cooperante’.",
    "tryFree": "Pruébalo Gratis →",
    "noCard": "Sin tarjeta de crédito · Reescrituras gratis incluidas",
    "list": [
      "Contrato de Listado — 14 campos, cada uno explicado",
      "Contrato de Compra — precio, contingencias, cierre, todo desglosado",
      "Divulgación del Vendedor — techo, HVAC, daños por agua, obligaciones legales",
      "Contrato de Arrendamiento — renta, depósito, mascotas, subarriendo, todo cubierto",
      "Contrato de Representación del Comprador — compensación, plazo, territorio"
    ]
  },
  "dashboard": {
    "sectionLabel": "/ Panel",
    "headline": "Todo detrás de un solo inicio de sesión.",
    "tabs": [
      "Generador",
      "Paquetes de Contenido",
      "Contratos",
      "Marca"
    ],
    "open": "Abrir Panel →",
    "freeNote": "Cuenta gratis · Primeras 3 reescrituras incluidas · Sin tarjeta de crédito"
  },
  "features": {
    "sectionLabel": "/ Especificaciones",
    "headline": "Construido como herramienta.",
    "headline2": "Lee como humano.",
    "items": [
      { "title": "Reescritura en 5 formatos", "body": "MLS, Instagram, Facebook, titulares, email — todo en un solo pase. Tu borrador aburrido se convierte en cinco activos listos para publicar." },
      { "title": "Reconocimiento de fotos", "body": "Sube fotos del listado. Detectamos mármol, madera dura, techos altos — y los traducimos en emociones." },
      { "title": "Cinco modos de tono", "body": "Lujo. Acogedor. Moderno. Familiar. Inversionista. La misma propiedad, ajustada para el comprador que realmente está buscando." },
      { "title": "31 plantillas sociales", "body": "Recién Listado, Vendido, Casa Abierta, Actualización de Mercado, Testimonio, Consejos — todo en tu voz de marca, listo para publicar." },
      { "title": "Pega cualquier URL", "body": "Ingresa un enlace de Zillow, Redfin o Realtor.com. Lo extraemos, obtenemos los detalles y precargamos tu reescritura en segundos." },
      { "title": "Calendario de 30 días", "body": "Un clic. Un mes completo de publicaciones sociales — plataforma, gancho, caption — basadas en tus listados activos y tu voz de marca." },
      { "title": "Actualizaciones de mercado", "body": "Ingresa cualquier código postal o ciudad. Obtén tres captions de actualización de mercado listos para publicar — Instagram, Facebook y email — con datos en vivo." },
      { "title": "Programador de publicaciones", "body": "Programa cualquier caption para después. Te enviamos un email con el contenido listo para copiar en el momento exacto." },
      { "title": "Cumplimiento Vivienda Justa + CO Act", "body": "Escanea cada listado en busca de violaciones citadas por HUD, genera automáticamente tu divulgación de la Ley de IA de Colorado y exporta un PDF de cumplimiento." },
      { "title": "Respuesta en 10 segundos", "body": "Generación promedio: diez segundos. Le gana por mucho al formulario típico de carga de MLS." },
      { "title": "Historial de listados", "body": "Cada reescritura guardada en tu sesión. Revisita, refina, regenera sin volver a escribir una sola palabra." },
      { "title": "Recorridos virtuales 360°", "body": "Conecta cualquier enlace de Matterport, Kuula o CloudPano. Los compradores exploran el hogar en 3D inmersivo desde tu listado." }
    ]
  },
  "guide": {
    "sectionLabel": "Documento No. 001",
    "heading": "La Guía. $20.",
    "desc": "45 páginas. Marco Característica → Beneficio → Sentimiento. 15 prompts de IA listos para copiar y pegar. Plantilla MLS de 5 partes. 6 reescrituras reales de antes/después con desgloses completos. Léela en una sentada — úsala en tu próximo listado el mismo día.",
    "features": [
      "La estructura de listado de 5 partes usada por agentes del 1% superior",
      "15 prompts listos para ChatGPT, Claude, Gemini",
      "Disparadores de psicología del comprador que generan visitas",
      "Fórmulas de titulares que detienen el desplazamiento en 1.2 segundos"
    ],
    "buy": "Compra la Guía — $20",
    "loading": "Cargando…",
    "preview": "Vista Previa",
    "guarantee": "30 días de garantía · Acceso vitalicio · Descarga instantánea",
    "docRef": "LWP-DOC-001",
    "rev": "REV. 02 / 2026",
    "stats": { "pages": "Páginas", "prompts": "Prompts IA", "rewrites": "Reescrituras", "price": "Una vez" },
    "modalTitle": "Guía ListWorks",
    "modalPreview": "Vista Previa · Páginas 1–4",
    "modalBuy": "Obtén la Guía Completa — $20",
    "moreInside": "Más adentro. Vale los $20.",
    "modalDesc": "Capítulo de Vivienda Justa · 15 prompts · psicología del comprador · tarjetas de bolsillo",
    "modalGuarantee": "30 días de garantía · descarga instantánea"
  },
  "testimonials": {
    "text": "Creado por un fundador. Est. 2026. Pruébalo con tu propio listado — el resultado es la prueba."
  },
  "exitPopup": {
    "sectionLabel": "/ Descarga Gratis",
    "heading1": "Antes de irte —",
    "heading2": "50 titulares que venden.",
    "desc": "50 titulares MLS de alta conversión, organizados por tipo de propiedad. Copia, pega, cierra más tratos. Gratis.",
    "moreLabel": "+ 45 más en tu bandeja de entrada",
    "placeholder": "tu@email.com",
    "send": "Envíame 50",
    "sending": "Enviando…",
    "noSpam": "Sin spam. Cancela cuando quieras.",
    "successTitle": "En camino.",
    "successDesc": "Revisa tu bandeja de entrada para 50 titulares que cierran.",
    "successCTA": "Prueba 3 Reescrituras Gratis Mientras Esperas →",
    "headlines": [
      "Aquella donde los pisos de madera encuentran los domingos por la mañana.",
      "Cuatro paredes. Fines de semana infinitos.",
      "La cocina que tus cenas han estado esperando.",
      "Todo lo que dijiste que esperarías. Está aquí.",
      "Esto es lo que 'llave en mano' realmente significa.",
      "Espacio para la vida que estás construyendo.",
      "Más que un hogar — un gran comienzo.",
      "El patio trasero que tus veranos han estado extrañando.",
      "Precio para moverse. Construido para quedarse.",
      "Donde el viaje termina y la vida comienza."
    ]
  },
  "fairHousing": {
    "banner": "Agentes de Colorado — Verificación de Divulgación IA",
    "bannerCTA": "Crea tu Registro Gratis →",
    "sectionLabel": "Vivienda Justa",
    "headline": "Vivienda Justa no fue diseñada para IA.",
    "desc": "Pero la multa de $26,000 de HUD por una sola violación aplica a quien sea que haya escrito el texto. ChatGPT no escanea señales de alerta de FHA. ListWorks PRO sí — cada reescritura, antes de que llegue a tu MLS.",
    "realExample": "Ejemplo real",
    "exampleBefore": "\"Perfecto para familias con niños y mascotas\"",
    "exampleAfter": "✓ Luz natural refrescante a través de un plano de piso abierto diseñado para la vida cotidiana.",
    "footer": "Misma casa. Mismo valor. Sin violación."
  },
  "viralNotifications": {
    "action": "generó un listado",
    "dismiss": "Descartar"
  },
  "presentation": {
    "sectionLabel": "/ Gana más Listados",
    "heading": "55 Páginas",
    "heading2": "Presentación de Venta",
    "subtitle": "Plantilla rellenable. Hojas de trabajo ACM, calculadora de ingreso neto, calendario de marketing, páginas de cumplimiento normativo. Funciona en tu navegador — sin software.",
    "buy": "Comprar Plantilla — $27",
    "previewAll": "Ver Todas las Páginas →",
    "viewFull": "Ver Vista Previa Completa →",
    "cover": "Portada",
    "cma": "Hoja de Trabajo ACM",
    "netProceeds": "Ingreso Neto",
    "mktgCalendar": "Calendario de Marketing",
    "sections": "36 Secciones Rellenables",
    "guarantee": "Descarga inmediata · HTML + PDF editable · Actualizaciones gratis · Garantía de 30 días"
  },
  "video": {
    "sectionLabel": "/ Motor de Video",
    "demo": "Demo en vivo",
    "headline1": "Diez fotos.",
    "headline2": "Un reel cinematográfico",
    "headline3": "listo.",
    "desc": "Sin software de edición. Sin horas extra. Solo sube las fotos de tu listado — la IA escribe el guión, elige la música y renderiza un recorrido de 30 segundos listo para Instagram, Facebook y tu campaña de email.",
    "inputLabel": "ENTRADA — 10 FOTOS CRUDAS",
    "outputLabel": "RENDERIZADO EN 8 SEGUNDOS",
    "overlay": "Generado por IA · Demo de 30s",
    "makeReel": "Hacer Mi Reel de Listado",
    "seePlans": "Ver planes →",
    "tapMusic": "Toca · activa la música",
    "tapForMusic": "Toca para música",
    "soundOn": "Sonido activado",
    "renderedIn": "RENDERIZADO EN 8 SEGUNDOS",
    "stats": [
      { "value": "10", "label": "Fotos" },
      { "value": "30s", "label": "Duración Final" },
      { "value": "1080p", "label": "Calidad MP4" },
      { "value": "9:16", "label": "Formato Reels (Pro)" }
    ]
  },
  "proof": {
    "sectionLabel": "/ Comprobantes",
    "headline": "El mismo listado. Su vecindario, escrito.",
    "before": "Antes",
    "beforeSub": "Borrador genérico",
    "after": "Después / ListWorks",
    "afterSub": "+ Inteligencia del Vecindario — auto-agregado",
    "strength": "Fuerza del Listado",
    "strengthScore": "{score}/10",
    "stronger": "+{percent}% más fuerte",
    "rewrite": "Reescribe el Tuyo",
    "freeCTA": "3 reescrituras gratis · Sin tarjeta de crédito · Ve la diferencia en 10 segundos",
    "examplesLabel": "/ Ejemplos Completos",
    "examplesTitle": "Pruébalos en el playground.",
    "examplesCTA": "Prueba tu dirección →",
    "neighborhood": "Inteligencia del Vecindario",
    "neighborhoodSub": "Pruébalo con cualquier dirección de EE.UU.",
    "neighborhoodPlaceholder": "Empieza a escribir una dirección...",
    "neighborhoodFetch": "Buscar",
    "neighborhoodSchools": "Escuelas",
    "neighborhoodDining": "Restaurantes",
    "neighborhoodTransit": "Transporte",
    "neighborhoodEmpty": "aparecerá aquí",
    "neighborhoodAdd": "Agregar a mi listado",
    "geoloading": "Obteniendo escuelas, restaurantes y datos de tránsito…",
    "addToListing": "Agregar a mi listado",
    "addDesc": "Ingresa cualquier dirección — el párrafo del vecindario se agrega a tu borrador automáticamente.",
    "neighborhoodParagraph": "Párrafo del vecindario — listo para pegar",
    "exampleOutput": "Ejemplo de salida",
    "liveResult": "Resultado en vivo",
    "fetchError": "No se pudieron obtener los datos del vecindario — verifica la dirección e inténtalo de nuevo."
  }
}
